import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategorySpendRow } from '../../models/authorization.model';

@Component({
  selector: 'ppl-spending-plan-overview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spending-plan-overview.component.html',
  styleUrl: './spending-plan-overview.component.css'
})
export class SpendingPlanOverviewComponent {
  @Input() overallBudgetSummary: any;
  @Input() spentCurrentMonth: number = 0;
  @Input() categoryBreakdown: CategorySpendRow[] = [];
  @Input() noAllocation = false;

  @Output() categorySelect = new EventEmitter<CategorySpendRow>();
  @Output() allDetailsSelect = new EventEmitter<void>();

  get totalBudgeted(): number {
    return this.overallBudgetSummary?.total ?? 0;
  }

  get totalSpent(): number {
    return this.overallBudgetSummary?.spent ?? 0;
  }

  get available(): number {
    return this.overallBudgetSummary?.remaining ?? 0;
  }

  get percentUsed(): number | null {
    return this.percentOf(this.totalSpent, this.totalBudgeted);
  }

  percentOf(spent: number, budgeted: number): number | null {
    if (!budgeted) {
      return null;
    }
    return (spent / budgeted) * 100;
  }

  /** Meters never overflow their track, however far over budget the spend runs. */
  meterWidth(percent: number | null): number {
    return Math.min(Math.max(percent ?? 0, 0), 100);
  }

  /** Fill and track step together, so utilisation state reads across the whole bar. */
  severity(percent: number | null): string {
    if (percent === null) {
      return 'is-empty';
    }
    if (percent >= 90) {
      return 'is-danger';
    }
    if (percent >= 70) {
      return 'is-warn';
    }
    return 'is-ok';
  }
}
